import AIWatchlistPanel from '../AIWatchlistPanel';
import ExecutionLogs from '../ExecutionLogs';
import FallbackWatchlistPanel from '../FallbackWatchlistPanel';
import HoldingsPanel from '../HoldingsPanel';
import MarketStatusBadge from '../MarketStatusBadge';
import PaperWatchlistPreviewPanel from './PaperWatchlistPreviewPanel';
import TossLiveWatchlistPanel from './TossLiveWatchlistPanel';
import type { CrossMarketStatus } from '../../services/crossMarketApi';
import type { useStrategyExecution } from '../../hooks/useStrategyExecution';

type StrategyState = ReturnType<typeof useStrategyExecution>;

export default function UsStrategyExecutionPanel({
  state,
  status,
}: {
  state: StrategyState;
  status: CrossMarketStatus | null;
}) {
  const live = isUsLive(status);
  const liveWatchlist = status?.markets.US.live_watchlist;

  return (
    <>
      <MarketStatusBadge />
      <section className="execution-summary">
        <Summary label="스케줄러" value={live ? 'Toss US live_pilot' : 'Alpaca paper'} />
        <Summary label="UI 갱신" value={`${state.uiRefreshInterval / 60000}분 주기`} />
        <Summary label="최근 로그" value={`${state.logs.length}건`} />
        <Summary label="Watchlist" value={live
          ? `${liveWatchlist?.count || 0}개`
          : `${state.aiStocks.length}개`} />
      </section>
      <HoldingsPanel
        onExecute={state.handleManualExecute}
        executingSymbol={state.executingSymbol}
      />
      {live ? (
        <>
          <TossLiveWatchlistPanel watchlist={liveWatchlist} />
          <PaperWatchlistPreviewPanel />
        </>
      ) : state.aiError && state.aiStocks.length === 0 ? (
        <FallbackWatchlistPanel
          onExecute={state.handleManualExecute}
          executingSymbol={state.executingSymbol}
        />
      ) : (
        <AIWatchlistPanel
          stocks={state.aiStocks}
          loading={state.aiLoading}
          error={state.aiError}
          countdown={state.countdown}
          onRefresh={state.handleManualRefresh}
          onExecute={state.handleManualExecute}
          executingSymbol={state.executingSymbol}
        />
      )}
      <div className="scheduler-status">
        <div className="status-item">
          <span className="status-indicator running"></span>
          <span>{live ? 'US Toss live_pilot 스케줄러 실행 중' : 'US paper 백그라운드 스케줄러 실행 중'}</span>
        </div>
        <div className="status-info">
          <p>{state.uiRefreshInterval / 60000}분마다 자동 전략 실행 및 UI 갱신</p>
          <p>{live
            ? '현재 US 후보는 Toss 검증을 통과한 live_pilot watchlist입니다. Gemini raw/paper 후보는 live 주문에 사용하지 않습니다.'
            : '현재 US 후보는 Alpaca paper 검증용입니다. Toss LIVE 후보는 Toss 검증 경로를 통과해야 합니다.'}</p>
        </div>
      </div>
      <ExecutionLogs logs={state.logs} />
    </>
  );
}

function Summary({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <span className="summary-label">{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

function isUsLive(status: CrossMarketStatus | null) {
  const safety = status?.safety;
  return Boolean(
    safety?.trading_mode === 'live'
    && safety.live_trading_enabled
    && safety.toss_live_market === 'US'
    && safety.toss_us_live_enabled
  );
}
